/* Try-on gallery badge — generico via metafield (window.__TRYON iniettato da theme.liquid) */
(function(){
  var T = window.__TRYON;
  if(!T || !T.model) return;
  var url = '/pages/prova-virtuale?model=' + encodeURIComponent(T.model)
          + '&title=' + encodeURIComponent(T.title || '')
          + '&handle=' + encodeURIComponent(T.handle || '')
          + (T.variantId ? '&vid=' + T.variantId : '');

  var icon = document.createElement('a');
  icon.id = 'tryon-gallery-badge';
  icon.href = url;
  icon.setAttribute('aria-label', 'Prova virtuale');
  icon.title = 'Prova virtuale';
  icon.style.cssText = 'position:absolute;top:14px;right:14px;z-index:5;width:44px;height:44px;'
    + 'border-radius:50%;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.22);display:flex;'
    + 'align-items:center;justify-content:center;color:#1a2c4e;transition:transform .15s;';
  icon.innerHTML = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="7" cy="13" r="3.2"/><circle cx="17" cy="13" r="3.2"/><path d="M10.2 13c.6-.8 3-.8 3.6 0"/><path d="M3.8 13 2.5 9.5M20.2 13l1.3-3.5"/></svg>';
  icon.onmouseenter = function(){ this.style.transform = 'scale(1.1)'; };
  icon.onmouseleave = function(){ this.style.transform = 'scale(1)'; };

  function variantOk(){
    if(!T.variantId) return true;
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if(!inp) return true;
    return String(T.variantId).split(',').indexOf(String(inp.value)) !== -1;
  }
  function update(){
    icon.style.display = variantOk() ? 'flex' : 'none';
  }
  function mount(){
    if(document.getElementById('tryon-gallery-badge')) return true;
    var g = document.querySelector('.product-media-box.gallery-media')
         || document.querySelector('.product-gallery');
    if(!g) return false;
    if(getComputedStyle(g).position === 'static') g.style.position = 'relative';
    g.appendChild(icon);
    update();
    return true;
  }
  // la variante selezionata puo' cambiare senza eventi affidabili: check leggero periodico
  setInterval(update, 700);
  if(!mount()){
    document.addEventListener('DOMContentLoaded', mount);
    setTimeout(mount, 600);
    setTimeout(mount, 1500);
  }
})();
